// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1939":"9e962f7a","3326":"1615e157","3932":"34c451da","4629":"9e962f7a","4665":"9e962f7a","5923":"d577751e","8121":"9e962f7a"}[chunkId] + ".chunk.css";
};